import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { GeneralService } from 'src/app/api/config/general.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-concept-expense-extends',
  templateUrl: './concept-expense-extends.component.html',
  styleUrls: ['./concept-expense-extends.component.css']
})
export class ConceptExpenseExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;

  constructor(
    public fb: FormBuilder,
    private generalService: GeneralService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      description: [null, [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description_concept')).focus();
    }, 500);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    this.LoadingModalComponent.show();
    this.generalService.saveConceptExpenses(this.item.value).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success('Registro realizado con éxito');
        this.onSubmitEvent.emit(data.data);
        this.LoadingModalComponent.hide();
        (<any>$('#openExtendsConceptExpense')).modal('hide');
        this.resetForm();
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.item.reset();
  }
  
}